import TaskDetailScreen from '../../../src/screens/TaskDetailScreen';

export default function TaskDetailRoute() {
  return <TaskDetailScreen />;
}
